import { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Spinner, Stack, Text } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import { PageHeader, SectionCard } from "../../../shared/ui";
import { useAuth } from "../../auth/hooks/useAuth";
import { BILLING_STATUS_KEY } from "../hooks/useBillingStatusQuery";

// O aviso de pagamento (webhook) pode chegar alguns segundos depois do médico voltar do
// gateway — revalida o /me algumas vezes antes de desistir.
const POLL_INTERVAL_MS = 3000;
const MAX_ATTEMPTS = 10;

// Destino do redirecionamento do gateway depois do pagamento.
export default function CheckoutReturnPage() {
  const { user, refetchMe } = useAuth();
  const queryClient = useQueryClient();
  const [attempts, setAttempts] = useState(0);
  const confirmed = user?.plan === "subscriber";

  useEffect(() => {
    if (confirmed || attempts >= MAX_ATTEMPTS) {
      queryClient.invalidateQueries({ queryKey: BILLING_STATUS_KEY });
      return undefined;
    }
    const timer = setTimeout(
      () => {
        refetchMe();
        setAttempts((n) => n + 1);
      },
      attempts === 0 ? 0 : POLL_INTERVAL_MS
    );
    return () => clearTimeout(timer);
  }, [attempts, confirmed, refetchMe, queryClient]);

  return (
    <>
      <PageHeader title="Assinatura" />
      <SectionCard maxW="640px">
        {confirmed ? (
          <Stack spacing={4} align="flex-start">
            <Text fontWeight="semibold">Pagamento confirmado. Obrigado por assinar o MedStation!</Text>
            <Text fontSize="sm" color="app-muted-fg">
              Sua conta já está liberada, com vínculos ilimitados.
            </Text>
            <Button as={RouterLink} to="/dashboard" size="sm">
              Ir para a visão geral
            </Button>
          </Stack>
        ) : attempts < MAX_ATTEMPTS ? (
          <Stack spacing={3} align="center" py={6}>
            <Spinner />
            <Text fontSize="sm" color="app-muted-fg">
              Confirmando o pagamento…
            </Text>
          </Stack>
        ) : (
          <Stack spacing={4} align="flex-start">
            <Text fontWeight="semibold">Ainda não recebemos a confirmação do pagamento.</Text>
            <Text fontSize="sm" color="app-muted-fg">
              Pix e cartão costumam confirmar em instantes; boleto leva até 3 dias úteis. Assim que
              o pagamento for confirmado, sua conta é liberada sozinha — você pode acompanhar pelo
              perfil.
            </Text>
            <Button as={RouterLink} to="/perfil" size="sm" variant="outline">
              Ver minha assinatura
            </Button>
          </Stack>
        )}
      </SectionCard>
    </>
  );
}
